<template>
  <div class="pull-auto top-menu">
    <el-menu :default-active="activeIndex" mode="horizontal">
      <template v-for="(item,index) in items">
        <el-menu-item :index="item.parentId+''" @click.native="openMenu(item)" :key="index">{{item.label}}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import {resolveUrlPath} from "@/util/util";
  import {mapState, mapGetters} from "vuex";

  export default {
    name: "top-menu",
    data() {
      return {
        activeIndex: "0",
        items: [
//        {
//          label: "首页",
//          href: "/wel/index",
//          parentId: 0
//        }
        ]
      };
    },
    created() {
    },
    computed: {
      ...mapGetters(["tagCurrent", "menu"])
    },
    methods: {
      openMenu(item) {
        this.$store.dispatch("GetMenu", item.parentId).then(data => {
          let itemActive,
            childItemActive = 0;
          if (item.href) {
            itemActive = item;
          } else {
            if (this.menu[childItemActive].length == 0) {
              itemActive = this.menu[childItemActive];
            } else {
              itemActive = this.menu[childItemActive].children[childItemActive];
            }
          }
          this.$router.push({
            path: resolveUrlPath(itemActive.href, itemActive.label)
          });
        });
      }
    }
  };
</script>

<style scoped="scoped" lang="scss">
  .top-menu {
    box-sizing: border-box;
    .el-menu {
      background-color: #344762;
      .el-menu-item {
        height: 40px;
        line-height: 40px;
        border-bottom: 0;
        color: #fff !important;
      }
      .el-menu-item:not(.is-disabled):focus,
      .el-menu-item:not(.is-disabled):hover {
        background-color: #344762;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// top-menu.vue?7b82905e